/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { CostCenter, RoutingService } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { CurrentItemService } from '../../shared/current-item.service';
import {CostCenterService} from "../../../core/services";
import {ROUTE_PARAMS} from "../../../root/route-params";

@Injectable({
  providedIn: 'root',
})
export class CurrentCostCenterService extends CurrentItemService<CostCenter> {
  constructor(
    protected routingService: RoutingService,
    protected costCenterService: CostCenterService
  ) {
    super(routingService);
  }

  protected getParamKey() {
    return ROUTE_PARAMS.costCenterCode;
  }

  protected getItem(code: string): Observable<CostCenter> {
    return this.costCenterService.get(code);
  }

  getError(code: string): Observable<boolean> {
    return this.costCenterService.getErrorState(code);
  }
}
